export default __webpack_public_path__ + "dad7207ee1ce2f06bce74010d3b0f13a.png";